<template>
    <EditingDialog
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :useDifferentShowDialogProp="true"
        maxDialogWidth="1200"
        maxCardHeight="800"
    >
        <template v-slot:editForm>
            <v-row>
                <v-col>
                    <BaseEditPageDropdown 
                        field="SourceAlvId"
                        :label="$t('lang_GENERIC_CAPTION_SOURCE')"
                        :items="sourceOptions"
                        :context="context"
                        :alvqa="alvqa + '-dropdown-source'"
                    />   
                </v-col>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="OtherId"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_WORK_ID')"
                        :withMargin="false"
                        rules="required"
                        :alvqa="alvqa + '-textfield-other-id'"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageDropdown 
                        :context="context"
                        :label="$t('lang_GENERIC_CAPTION_COUNTRY')" 
                        :items="countryItems" 
                        field="Country"
                        :alvqa="alvqa + '-dropdown-country'"
                        :withMargin="false"
                    />
                </v-col>
            </v-row>
        </template>
    </EditingDialog>
</template>

<script>
import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'

export default {
    name: "OtherIdsEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageTextField,
        BaseEditPageDropdown
    },
    data() {
        return {
            context: "WorksOtherIds",
            alvqa: "publishing-works-edit-form-other-ids-panel-editing-dialog"
        }
    },
    computed: {
        countryItems() {
            return this.$alvPlugin.getListOfTranslatedCountries()
        },  
        sourceOptions() {
            return this.$store.getters.getAzForOtherIdsSource
        },
    },
    methods: {
        getCountry(countryCode) {            
            return this.$alvPlugin.getTranslatedCountryName(countryCode, true)
        },
        onSourceChange(newVal) {
            // Find the selected option (which has { value, text }).
            const selectedOption = this.sourceOptions.find(source => source.value === newVal);
            if (!selectedOption) {
                console.warn("No matching source option found for", newVal);
                return;
            }
            
            const fullSourceObject = {
                alvId: selectedOption.value,
                name: selectedOption.text,
                // For example, if you expect a society abbreviation and other properties, add them:
                societyAcronym: selectedOption.societyAcronym || null, 
                group: selectedOption.text,
                typeOfAZ: newVal.slice(-1),
            };

            // Update the dialog details.
            let details = { ...this.$store.getters.getWorksOtherIdsEditingDialogDetails };
            details.SourceAlvId = newVal;         // update the ALVID field
            details.sourceObject = fullSourceObject; // store the full source object
            details.sourceName = fullSourceObject.name; // and store the name explicitly
            this.$store.commit('setWorksOtherIdsEditingDialogDetails', details);

            // Immediately update the main array used by the table.
            let items = [...this.$store.getters.getWorksOtherIds];
            const index = items.findIndex(item => item.id === details.id);
            if (index !== -1) {
                // Use Vue.set to force reactivity.
                this.$set(items, index, details);
            } else {
                items.push(details);
            }
            console.log(items)
            this.$store.commit('setWorksOtherIds', items);
        },
    },
}
</script>